module.exports = __webpack_public_path__ + "fonts/dac0e60.ttf";